'use strict';

/**
 * birt Service
 */
module.service('birtService', [ 'dateUtilService', birtServiceFn ]);

function birtServiceFn(dateUtil) {
	var ss = {};

	ss.exportExcel = function(idClient, idState, takenDateStart, takenDateEnd, analysisDateStart, analysisDateEnd) {
		var url = '/asebiol-birt/run?__title=Exportar%20en%20Excel&__format=xlsx&__report=samplesConsolidatedReport.rptdesign';
		if (idClient) {
			url += "&clientId=" + idClient;
		}
		if (idState) {
			idState.forEach(function(v) {
				url += "&pStateSample=" + v;
			});
		}
		if (dateUtil.isValid(takenDateStart) && dateUtil.isValid(takenDateEnd)) {
			url += "&takenDateStart=" + dateUtil.toBirtDate(takenDateStart);
			url += "&takenDateEnd=" + dateUtil.toBirtDate(moment(takenDateEnd).add(1, 'day'));
		}
		if (dateUtil.isValid(analysisDateStart) && dateUtil.isValid(analysisDateEnd)) {
			url += "&analysisDateStart=" + dateUtil.toBirtDate(analysisDateStart);
			url += "&analysisDateEnd=" + dateUtil.toBirtDate(moment(analysisDateEnd).add(1, 'day'));
		}

		return url;
	}
	
	ss.workSheetAnalysis =  function(ana){
		var url ="/asebiol-birt/run?__title=Informe%20de%20Muestras&__format=pdf&__report=@@reporte@@.rptdesign&analysisType="+ana.id;
		if(ana.value == "MB"){
			url = url.replace(/@@reporte@@/i, "ht_analysisSamples");
		}else{
			url = url.replace(/@@reporte@@/i, "ht_analysisSamplesNoTubes");
		}
		return url;
	}
	
	return ss;
}